import type { SanityProgrammeType } from '@/types/sanity';

const categories = (programmes): SanityProgrammeType['category'][] => [
  ...new Set<SanityProgrammeType['category']>(
    programmes?.map((programme) => programme.category),
  ),
];

export { categories };
